import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const Container = ({ border, children, width, minWidth }: ContainerProps) => (
  <StyledContainer border={border} width={width} minWidth={minWidth}>{children}</StyledContainer>
);

export default Container;
